// @flow

export default {
  path: '/visitas',
  component: () => import('modules/redirectIconList/IconListVisits.vue'),
  children: [
    {
      path: '',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'Visitas',
            name: 'Visit'
          }
        ]
      },
      name: 'Visit',
      component: () => import('modules/redirectIconList/IconListVisits.vue')
    }
  ]
};
